import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { TypeCredit } from "src/app/parametrage/core/model/type-credit";
import { Produit } from "src/app/parametrage/core/model/produit";
import { TypeCreditService } from "src/app/parametrage/core/service/type-credit.service";
import { ProduitService } from "src/app/parametrage/core/service/produit.service";
import { ProfessionnelItem } from "src/app/professionnel/core/model/professionnel-item";
import { ConfirmerProfessionnelItem } from "src/app/professionnel/core/model/confirmer-credit";
import { ProfessionnelItemService } from "src/app/professionnel/core/service/professionnel-item.service";

@Component({
  selector: "app-confirm-credit-modal",
  templateUrl: "./confirm-credit-modal.component.html",
  styleUrls: ["./confirm-credit-modal.component.scss"],
})
export class ConfirmCreditModalComponent implements OnInit {
  @Input() professionnelItemId;
  @Input() workflowCode;

  professionnelItem: ProfessionnelItem;

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  confirmerProfessionnelItem: ConfirmerProfessionnelItem =
    new ConfirmerProfessionnelItem();

  constructor(
    private _professionnelItemService: ProfessionnelItemService,
    private _typeCreditService: TypeCreditService,
    private _produitService: ProduitService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      montantAccorde: [null, Validators.compose([Validators.required])],
      tauxAccorde: [null, Validators.compose([Validators.required])],
      echeanceAccorde: [null, Validators.compose([Validators.required])],
      commissionEngagementAccorde: [
        null,
        Validators.compose([Validators.required]),
      ],
      typeTirage: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getProfessionnelItemById(this.professionnelItemId);
  }

  getProfessionnelItemById(requestItemId) {
    this._professionnelItemService
      .getProfessionnelItemById(requestItemId)
      .subscribe(
        (data) => {
          this.professionnelItem = data;

          this.confirmerProfessionnelItem.montantAccorde =
            this.professionnelItem.montant;
          this.confirmerProfessionnelItem.tauxAccorde =
            this.professionnelItem.taux;
          this.confirmerProfessionnelItem.echeanceAccorde =
            this.professionnelItem.echeance;
          this.confirmerProfessionnelItem.typeTirage =
            this.professionnelItem.typeTirage;
          this.confirmerProfessionnelItem.commissionEngagementAccorde =
            this.professionnelItem.commissionEngagement;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  update(): void {
    this.spinner.show();

    this.confirmerProfessionnelItem.professionnelItemId =
      this.professionnelItemId;

    this._professionnelItemService
      .confirmer(this.confirmerProfessionnelItem)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
